import { AbstractLocaleMessageObject } from "@/i18n/AbstractLocaleMessageObject"

export class CommonPagingControlPartsJa extends AbstractLocaleMessageObject {
  readonly tableDropDownPageCount: string = "{count}件表示"
}
